import { useSyncExternalStore } from 'react';

import { getDeviceToken, subscribeDeviceToken } from './deviceToken';

/**
 * Reactive view of the paired device token. Re-renders when the device is paired
 * (token set) or when a revoke/401 clears it. `null` => show the pairing screen.
 */
export function useDeviceToken(): string | null {
  return useSyncExternalStore(subscribeDeviceToken, getDeviceToken, getDeviceToken);
}
